import "./loader.scss"
import spritemap from "@milestone-sys/web-design-system/msds-spritemap.svg"
import { useAppSelector } from "reducers/hooks"
import { selectAreProjectsLoading } from "reducers/fell/projects/projectsSlice"
import { selectServerSettingsLoading } from "reducers/fell/serverSettings/serverSettingsSlice";
import { selectAreSiteDesignsLoading } from "reducers/fell/siteDesign/siteDesignSlice"
import { selectAreSitesLoading } from "reducers/fell/sites/sitesSlice"
import { selectIsSiteDesignEditorLoading } from "reducers/fell/siteDesignEditor/siteDesignEditorSlice"
import { selectisSiteDesignEditorUpdating } from "../../reducers/fell/camera/cameraSlice";
import { selectBulkApplyLoading } from "../../reducers/fell/bulkapply/bulkApplySlice";
import { selectCalculationStatus } from "../../reducers/fell/proposals/proposalSlice";

export const globalLoadingState = {
    isForcedLoading: false
};

function Loader() {  
    const areProjectsLoading = useAppSelector(selectAreProjectsLoading)
    const areServerSettingsLoading = useAppSelector(selectServerSettingsLoading)
    const areSiteDesignsLoading = useAppSelector(selectAreSiteDesignsLoading)
    const areSitesLoading = useAppSelector(selectAreSitesLoading)
    const isSiteDesignEditorLoading = useAppSelector(selectIsSiteDesignEditorLoading)
    const isSiteDesignEditorUpdating = useAppSelector(selectisSiteDesignEditorUpdating)
    const isBulkApplyLoading = useAppSelector(selectBulkApplyLoading)
    const isCalculationLoading = useAppSelector(selectCalculationStatus)

    const isLoading =
        globalLoadingState.isForcedLoading
        || areProjectsLoading
        || areServerSettingsLoading
        || areSiteDesignsLoading
        || areSitesLoading
        || isSiteDesignEditorLoading
        || isSiteDesignEditorUpdating
        || isBulkApplyLoading
        || isCalculationLoading

    return (
        <>
            {isLoading && (
                <div className="content-overlay">
                    <div className="loader">
                        <svg className="loader__msds-loader">
                            <use href={`${spritemap}#loader-animated`} />
                        </svg>
                    </div>
                </div>
            )}
        </>
    )
}

export default Loader;
